var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86216 10.3931L6.96077 6.02404C7.04291 5.95361 7.10884 5.86625 7.15405 5.76795C7.19925 5.66965 7.22266 5.56273 7.22266 5.45454C7.22266 5.34634 7.19925 5.23942 7.15405 5.14112C7.10884 5.04282 7.04291 4.95546 6.96077 4.88504L1.86216 0.515962C1.37549 0.0989957 0.623766 0.444696 0.623766 1.08546L0.623766 9.82486C0.623766 10.4656 1.37549 10.8113 1.86216 10.3931Z",
    fill: "#2d5644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.531a563132a9ef4a8476bc8c5151e70b.svg";
export { ForwardRef as ReactComponent };